module.exports = "<navbar></navbar>\n\n<h1>Not Found</h1>\n<p> the page you are looking for does not exist, \n  please use the navbar above to go to a page that does exist.</p>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/notfound/notfound.component.html
// module id = ../../../../../src/app/notfound/notfound.component.html
// module chunks = main